export function affectsLegacyProgress(event) {
  if (["learner-quiz-completed", "learner-assessment-reviewed"].includes(event?.type)) return true;
  const { callableName = "", systemName = "", operation = "" } = event?.detail || {};
  if (["read", "fetch", "get", "list", "query"].includes(operation)) return false;
  const name = String(callableName).toLowerCase();
  const system = String(systemName).toLowerCase();
  if (name.includes("tracking")) return false;
  return /assessment|baseline|grade|quizsubmission|studentscore|studentprogress/.test(name) ||
    /assessment|grade|quizsubmission|learnerassessmentstory|program/.test(system);
}
